export default __webpack_public_path__ + "static/archive_and_cleanup-c5f4b0c31a311f6513e2d6b91d62c8c2.svg";